import useMenuItems, { FILTER_SET_MENU_KEYS } from './useMenuItems';

const useFilterSetMenuItemByKey = (Context, key) => {
  const menuItems = useMenuItems(Context);
  const allowedKeys = Object.values(FILTER_SET_MENU_KEYS);

  if (!allowedKeys.includes(key))
    throw new Error(
      `useFilterSetMenuItemByKey key: ${key} is illegal. please use a key from FILTER_SET_MENU_KEYS`
    );

  const menuItem = menuItems?.find(menuItem => menuItem?.key === key);

  return menuItem;
};

export default useFilterSetMenuItemByKey;
